import { useContractsImporter } from 'modules/employees/components/ContractImporter/contractsImporterContext'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'
import ImportModeSelect from 'modules/employees/pages/ImportContractsPage/components/ImportMode'

const ImportContractsModeSelectPage = () => {
  const onClose = useOnCloseGoToList()
  const importer = useContractsImporter()

  return <ImportModeSelect onClose={onClose} importer={importer} />
}

export default ImportContractsModeSelectPage
